<script setup lang="ts">
import { Input as VarInput, type InputProps } from '@varlet/ui';
import { useSlots } from 'vue';

import { type FieldErrors } from '@/shared/lib';

import { FieldErrorsList } from './index';

const value = defineModel<string | undefined>({ default: '' });

const {
  type,
  placeholder,
  size,
  focusColor,
  clearable,
  preventAutoFill,
  autocomplete,
  name,
  errors,
  rules,
} = defineProps<{
  type: InputProps['type'];
  placeholder?: string;
  size?: InputProps['size'];
  focusColor?: InputProps['focusColor'];
  clearable?: InputProps['clearable'];
  preventAutoFill?: InputProps['preventAutoFill'];
  autocomplete?: string;
  name?: string;
  inputmode?: InputProps['inputmode'];
  errors?: FieldErrors;
  rules?: InputProps['rules'];
}>();

const emit = defineEmits<{ (e: 'focus'): void }>();

const slots = useSlots();
</script>

<template>
  <VarInput
    v-model="value"
    :type="type"
    variant="outlined"
    blur-color="var(--field-decorator-disabled-color)"
    :placeholder="placeholder"
    :size="size"
    :focus-color="focusColor"
    :clearable="clearable"
    :prevent-auto-fill="preventAutoFill"
    :autocomplete="autocomplete"
    :name="name"
    :inputmode="inputmode"
    :rules="rules"
    @focus="() => emit('focus')"
  >
    <template
      v-if="slots['prepend-icon']"
      #prepend-icon
    >
      <slot name="prepend-icon" />
    </template>

    <template
      v-if="slots['append-icon']"
      #append-icon
    >
      <slot name="append-icon" />
    </template>

    <template
      v-if="errors"
      #extra-message
    >
      <FieldErrorsList :errors="errors" />
    </template>
  </VarInput>
</template>
